import { createSlice } from "@reduxjs/toolkit";

export const RevenueSlice = createSlice({
  name: "revenue",
  initialState: {
    revenue: {},
  },
  reducers: {
    saveRevenueData: (state, action) => {
      state.revenue = action.payload;
    }
  }
});

export const { saveRevenueData } = RevenueSlice.actions;
export default RevenueSlice.reducer;